"use client";

import { Scale, MapPin, Landmark, Award, Languages } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Leadership() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: itemsRef,
    isVisible: itemsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const credentials = [{
    icon: Scale,
    label: "SINCE 1983",
    description: "Providing dedicated legal counsel for over four decades."
  }, {
    icon: Landmark,
    label: "U.S. SUPREME COURT",
    description: "Admitted to practice\nbefore the United States Supreme Court."
  }, {
    icon: Award,
    label: "U.S. SUPREME COURT",
    description: "Former Chair of the Florida Bar Grievance Committee."
  }, {
    icon: Languages,
    label: "PROFESSIONAL LEADERSHIP",
    description: "Past Chairman of the Board of Directors of Legal Aid.\n\n\xA0Past Chairman of the Board of Directors of Coast to Coast.\n\n\xA0Past President of the Stephen R. Booher Inn of Court."
  }];
  const leadershipRoles = [{
    organization: "Legal Aid",
    role: "Past Chairman of the Board of Directors"
  }, {
    organization: "Coast to Coast",
    role: "Past Chairman of the Board of Directors"
  }, {
    organization: "Stephen R. Booher Inn of Court",
    role: "Past President"
  }];
  return <section data-section-id="4418" id="professionalleadership" className="relative overflow-hidden bg-background py-20 text-foreground md:py-28 lg:py-32">
    <div aria-hidden="true" className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 opacity-25 blur-2xl md:h-96 md:w-96" style={{
      backgroundColor: "var(--chart-3)"
    }} />

    <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
      <div ref={headerRef} className={`mx-auto max-w-3xl text-center transition-all duration-1000 ease-out ${headerVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`}>
        <p className="mb-6 font-default text-xs uppercase tracking-[0.25em]" style={{
          color: "var(--secondary)"
        }}>
          Experience & Professional Leadership
        </p>

        <h2 className="font-default text-4xl leading-[1.05] tracking-tight text-foreground md:text-5xl lg:text-6xl" style={{
          fontFamily: "var(--font-serif)"
        }}>
          Professional Experience &amp; Leadership
        </h2>

        <p className="mt-6 font-default text-base leading-relaxed md:text-lg" style={{
          color: "var(--muted-foreground)"
        }}>
          Professional judgment shaped by more than four decades of legal
          practice, leadership within The Florida Bar and South Florida legal
          organizations, and admission before the United States Supreme Court.
        </p>
      </div>

      <div ref={itemsRef} className="mt-16 md:mt-20">
        <div className={`mt-0 transition-all delay-300 duration-700 ease-out md:mt-0 ${itemsVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`}>
          <div className="mx-auto max-w-5xl">
            <div className="text-center">
              <p className="font-default text-xs uppercase tracking-[0.22em]" style={{
                color: "var(--secondary)"
              }}>
                Selected Leadership Roles
              </p>

              
            </div>

            <div className="mt-10 grid gap-5 md:grid-cols-3 md:gap-6">
              {leadershipRoles.map(item => <div key={item.organization} className="flex min-h-[150px] flex-col justify-center rounded-lg border bg-card px-6 py-7 text-center shadow-sm" style={{
                borderColor: "var(--border)"
              }}>
                  <h4 className="text-xl leading-snug text-foreground" style={{
                  fontFamily: "var(--font-serif)"
                }}>
                    {item.organization}
                  </h4>

                  <p className="mt-3 font-default text-sm leading-relaxed md:text-base" style={{
                  color: "var(--muted-foreground)"
                }}>
                    {item.role}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </div>
   </section>;
}